/* DeviceManager.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "device_manager",
    label: "Device Manager",
    disabled: false,
    order: 2, // Deprecated -- Newer solution uses order from index.js
    app: "GameConsole",
    section: "GameCenter",
    license: ["GLUWARE"],
    accessPerm: ["deviceManagerAccess"],
    pageTitle: "Gluware Device Manager",
    helpLink: "Device%20Manager/Manage-your-device-inventory.htm",
    navIcon: "device.solution",
    iconName: "branding.deviceManager",
    lmrbNamespaces: [
        Registrations.DEVICE_EXPLORER_ENTITY_LMRB,
        Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB,
        Registrations.SITE_EXPLORER_ENTITY_LMRB,
        Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB,
    ],
    editorNamespaces: [
        Registrations.DEVICE_INSTANCE_EDITOR,
        Registrations.NETWORK_DISCOVERY_EDITOR,
        Registrations.SITE_INSTANCE_EDITOR,
    ],
    siteExplorer: {
        viewNamespaces: [
            Registrations.SITE_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.SITE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
            Registrations.SITE_EXPLORER_VIEW_GRID,
            Registrations.SITE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER,
        ],
        actionNamespaces: [
            Registrations.SITE_EXPLORER_ACTION_CREATE_SITE,
            Registrations.SITE_EXPLORER_ACTION_EDIT,
            Registrations.SITE_EXPLORER_ACTION_MULTIEDIT,
            Registrations.SITE_EXPLORER_ACTION_IMPORT,
            Registrations.SITE_EXPLORER_ACTION_EXPORT,
            Registrations.SITE_EXPLORER_ACTION_DELETE,
            Registrations.SITE_EXPLORER_ACTION_CLONE,
            Registrations.SITE_EXPLORER_ACTION_AUTO_ASSIGNMENT,
        ],
    },
    networkDiscoveryExplorer: {
        viewNamespaces: [
            Registrations.NETWORK_DISCOVERY_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.NETWORK_DISCOVERY_SWITCH_TO_IOT_DEVICE_EXPLORER,
            Registrations.NETWORK_DISCOVERY_EXPLORER_SWITCH_TO_SITE_EXPLORER,
            Registrations.NETWORK_DISCOVERY_EXPLORER_GRID,
        ],
        actionNamespaces: [
            Registrations.NETWORK_DISCOVERY_ACTION_RUN,
            Registrations.NETWORK_DISCOVERY_ACTION_CREATE,
            Registrations.NETWORK_DISCOVERY_ACTION_EDIT,
            Registrations.NETWORK_DISCOVERY_ACTION_CLONE,
            Registrations.NETWORK_DISCOVERY_ACTION_DELETE,
            Registrations.NETWORK_DISCOVERY_ACTION_EXPORT,
            Registrations.NETWORK_DISCOVERY_ACTION_IMPORT,
        ],
    },
    siteEditor: {
        viewNamespaces: [
            Registrations.SIE_VIEW_DETAILS,
            Registrations.SIE_VIEW_SITES,
            Registrations.SIE_VIEW_DEVICES,
            Registrations.SIE_VIEW_ACTIVITY,
        ],
        actionNamespaces: [Registrations.SIE_ACTION_DELETE],
    },
    deviceExplorer: {
        viewNamespaces: [
            Registrations.DEVICE_EXPLORER_VIEW_GRID,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_SITE_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
        ],
        actionNamespaces: [
            Registrations.DEVICE_EXPLORER_ACTION_MULTIEDIT,
            Registrations.DEVICE_EXPLORER_ACTION_DISCOVERY,
            Registrations.DEVICE_EXPLORER_ACTION_CREATE,
            Registrations.DEVICE_EXPLORER_ACTION_CLONE,
            Registrations.DEVICE_EXPLORER_ACTION_IMPORT,
            Registrations.DEVICE_EXPLORER_ACTION_REPORT,
            Registrations.DEVICE_EXPLORER_ACTION_DELETE,
            Registrations.DEVICE_EXPLORER_ACTION_UPDATE_CISCO,
            Registrations.DEVICE_EXPLORER_ACTION_REBOOT_DEVICE,
            Registrations.DEVICE_EXPLORER_ACTION_ADHOC_QUERY,
            Registrations.DEVICE_EXPLORER_ACTION_QUALIFY_CVES,
            Registrations.DEVICE_EXPLORER_ACTION_EXPORT,
            Registrations.DEVICE_EXPLORER_ACTION_BACKUP,
            Registrations.DEVICE_EXPLORER_ACTION_RESTORE,
            Registrations.DEVICE_EXPLORER_ACTION_LINK_AND_SYNC,
        ],
    },

    iotDeviceExplorer: {
        viewNamespaces: [
            Registrations.IOT_DEVICE_EXPLORER_VIEW_GRID,
            Registrations.IOT_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.IOT_DEVICE_EXPLORER_SWITCH_TO_SITE_EXPLORER,
            Registrations.IOT_DEVICE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER,
        ],
        actionNamespaces: [
            Registrations.IOT_DEVICE_EXPLORER_ACTION_OFFLINE_DISCOVERY_DOWNLOAD,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_OFFLINE_DISCOVERY_UPLOAD,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_MULTIEDIT,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_LINK_AND_SYNC,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_REPORT,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_EXPORT,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_IMPORT,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_DELETE,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_COPY,
        ],
    },
    deviceEditor: {
        viewNamespaces: [
            Registrations.DIE_VIEW_DETAILS,
            Registrations.DIE_VIEW_CONFIG,
            Registrations.DIE_VIEW_ACTIVITY,
            Registrations.DIE_VIEW_EOX_BULLETIN,
            Registrations.DIE_VIEW_SMARTNET_DETAILS,
            Registrations.DIE_VIEW_ADVISORY_SUMMARY,
            Registrations.DIE_VIEW_EXPOSURE,
            Registrations.DIE_VIEW_AUDIT_SUMMARY,
            Registrations.DIE_VIEW_RESTORE,
        ],
        actionNamespaces: [
            Registrations.DIE_ACTION_DISCOVERY,
            Registrations.DIE_ACTION_BACKUP,
            Registrations.DIE_ACTION_DELETE,
        ],
    },
    networkDiscoveryEditor: {
        viewNamespaces: [
            Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
            Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_HISTORY,
            Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_RESULTS,
            Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_ACTIVITY,
        ],
        actionNamespaces: [
            Registrations.NETWORK_DISCOVERY_EDITOR_ACTION_RUN,
            Registrations.NETWORK_DISCOVERY_EDITOR_ACTION_DELETE,
        ],
    },
    AdhocQueryEditor: {
        viewNamespaces: [Registrations.ADHOC_QUERY_EDITOR_VIEW_DETAILS],
    },
    navOptions: {
        device: {
            name: "Devices",
            options: {
                exp: "device",
            },
            type: "exp",
        },
        iot_device: {
            name: "IoT Devices",
            options: {
                exp: "iot_device",
            },
            type: "exp",
        },
        site_explorer: {
            name: "Sites",
            options: {
                exp: "site",
            },
            type: "exp",
        },
        network_discovery: {
            name: "Network Discovery",
            options: {
                exp: "network_discovery",
            },
            type: "exp",
        },
    },
};
